import * as Sentry from "@sentry/react";
import {
	scrubbedBeforeBreadcrumb,
	scrubbedBeforeSend,
	scrubbedBeforeSendLog,
} from "./lib/phiScrub";

Sentry.init({
	dsn: "https://9bcc559c4844d42240ca195b111d83af@o4509068912558080.ingest.us.sentry.io/4510069921415168",
	// Explicitly set environment to ensure dev errors are captured
	environment: import.meta.env.MODE || "development",
	// HIPAA: D-11 — disable automatic PII collection (was true)
	sendDefaultPii: false,
	integrations: [
		Sentry.browserTracingIntegration(),
		// D-11 — replay masking: prevents rendered DOM PHI from being captured.
		// unmask/unblock left at default [] so no class-based opt-out can leak.
		Sentry.replayIntegration({
			maskAllText: true,
			maskAllInputs: true,
			blockAllMedia: true,
		}),
	],
	beforeSend: scrubbedBeforeSend,
	beforeBreadcrumb: scrubbedBeforeBreadcrumb,
	enableLogs: true,
	beforeSendLog: scrubbedBeforeSendLog,
	tracesSampleRate: 0.1,
	tracePropagationTargets: [
		"localhost",
		/^\//,
		/^https:\/\/.*\.ngrok\.app/,
		// Exclude Auth0 custom domains (login-*) to avoid CORS issues with tracing headers
		/^https:\/\/(?!login-)[\w-]+\.eraborn\.co/,
	],
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0,
});
